import { createSelector } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import { IStoreState } from "../../../../reducers/types";
import { TravelWalletOffer } from "redmond";
import { filterOutSpendAndGetOffers } from "halifax";

export const getAllTravelWalletOffers = (state: IStoreState) =>
  state.hotelTravelWallet.offers;

export const getTravelWalletOffers = createSelector(
  getAllTravelWalletOffers,
  (offers) => filterOutSpendAndGetOffers(offers)
);

export const getActiveTravelWalletOffers = createSelector(
  getTravelWalletOffers,
  (offers) => {
    return offers.filter((offer) => {
      return dayjs().isAfter(dayjs(offer?.saleEventStartOn));
    });
  }
);

export const getTravelWalletCredit = (state: IStoreState) =>
  state.hotelTravelWallet.credit;

export const getCreditBreakdown = (state: IStoreState) =>
  state.hotelTravelWallet.creditBreakdown;

export const getTravelCreditsHistoryTransaction = (state: IStoreState) =>
  state.hotelTravelWallet.creditsHistoryTransactions;

export const getPartialHistoryValidFromTime = (state: IStoreState) =>
  state.hotelTravelWallet.partialHistoryValidFromTime;

export const getActiveCrossSellOffers = createSelector(
  getTravelWalletOffers,
  (travelWalletOffers): TravelWalletOffer[] => {
    const activeCrossSellOffers = travelWalletOffers.filter((offer) => {
      return offer.imageId && offer.imageId.startsWith("CrossSellOffer");
    });
    return activeCrossSellOffers;
  }
);
